import type { Service } from '@360face/domain';

/**
 * Booking with a membership, opened from the client app (owner 26.10.2026): the membership's name
 * and the Hub services of this studio it covers. The covered treatments come first; the rest stay
 * one switch away and are paid separately.
 */
export interface BookingMembership {
  title: string;
  serviceIds: string[];
}

/** `?mem=<name>&incl=<id>,<id>` → the membership, or undefined. */
export function appMembership(params: URLSearchParams): BookingMembership | undefined {
  const title = params.get('mem')?.trim().slice(0, 120);
  if (!title) return undefined;
  const serviceIds = (params.get('incl') ?? '')
    .split(',')
    .map((x) => x.trim())
    .filter((x) => /^[a-z0-9-]{1,40}$/.test(x))
    .slice(0, 40);
  return { title, serviceIds };
}

export function coveredBy(mem: BookingMembership | undefined, service: Pick<Service, 'id'>): boolean {
  return Boolean(mem && mem.serviceIds.includes(service.id));
}

/** The comment the therapist sees in Altegio: the membership first, then the client's own words. */
export function bookingComment(mem: BookingMembership | undefined, comment: string | undefined): string | undefined {
  const parts = [mem ? `Abonamento: ${mem.title}` : '', comment?.trim() ?? ''].filter(Boolean);
  return parts.length ? parts.join('\n').slice(0, 300) : undefined;
}
